import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCreativePerformancePageViewed.meta';

export const useTrackCreativePerformancePageViewed = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreativePerformancePageViewed = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackCreativePerformancePageViewed };
};
